import React from "react";

import AllRoutes from "./Routes/AllRoutes";

import { ChakraProvider, Slider, theme } from "@chakra-ui/react";
import NavBar from "./Components/header.component";
import Banner from "./Components/Banner";
import customTheme from "./utils/theme";


function App() {
  return (
    <ChakraProvider theme={customTheme}>
      <Banner />
      <NavBar />
      <AllRoutes />
     
    </ChakraProvider>
  );
}

export default App;
